import React, { Component } from 'react'
import { Heading, Form, Price, RadioGroup, Text } from '@deseretbook/react-ui'

class ShippingRateSelector extends Component {
  constructor(props) {
    super(props)

    const { shipment } = props

    this.state = {
      selectedRate: shipment.shippingRates[0].id,
    }
  }

  render() {
    const { shipment } = this.props
    const { selectedRate } = this.state
    const shippingRates = shipment.shippingRates.map(rate => (
      <RadioGroup.Option key={rate.id} value={rate.id}>
        <Text>
          {rate.name}: <Price>{rate.cost}</Price>
        </Text>
      </RadioGroup.Option>
    ))

    return (
      <Form>
        <Heading>Select Shipping Method</Heading>
        <RadioGroup name="shippingRate" selectedValue={selectedRate}>
          {shippingRates}
        </RadioGroup>
      </Form>
    )
  }
}

export default ShippingRateSelector
